// src-mlr/app.route.dynamic.js

import appconfig from 'app/config';
import appcomponents from 'app/app.components';

routingDynamic.$inject = [
  '$rootScope', '$location', '$urlRouter', '$stateRegistry',
  '$ocLazyLoad', '$state', '$urlMatcherFactory', 'PageService'
];

export default function routingDynamic(
  $rootScope, $location, $urlRouter, $stateRegistry,
  $ocLazyLoad, $state, $urlMatcherFactory, PageService
) {
  const ERROR_STATE = 'error';
  const API_PAGE_CONTENT_PATH = appconfig.production ? appconfig.api + 'mlr/content' : appconfig.apiv3 + 'mlr/content/mlr';
  const EXCLUDED_PATHS = ['/error', '/clear-cache', '/'];
  let lastFetchedPath = null; // Avoid double fetching

  $urlMatcherFactory.caseInsensitive(true);
  $urlMatcherFactory.strictMode(false);

  // Helper: fetch page data from API
  async function fetchPageContent(path) {

    const response = await fetch(API_PAGE_CONTENT_PATH + path);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();

    if (responseData.status === ERROR_STATE) {
      PageService.resetGlobalPage();
      $state.go(ERROR_STATE, {}, {
        reload: true
      });
      return;
    }
    const page = responseData.data;
    PageService.setGlobalPage(page);
    return page;

  }

  // Helper: Handle dynamic routing logic
  function handleDynamicRoute(path, queryParams) {
    fetchPageContent(path)
      .then(page => {
        $rootScope.page = page;
        const component = appcomponents[page.type];
        const stateName = page.type;
        const stateExists = $stateRegistry.get(stateName);

        const state = {
          url: `/${page.slug}?${Object.keys(queryParams).join('&')}`,
          cache: false,
          name: stateName,
          component,
          params: queryParams,
          caseInsensitiveMatch: true,
          lazyLoad: async ($transition$) => {
            const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
            try {
              const mod = await import(`./views/${page.type}/${page.type}.view`);
              await $ocLazyLoad.load(mod[component.toUpperCase() + '_VIEW']);
            } catch (err) {
              throw new Error(`Ooops, something went wrong, ${err}`);
            }

          }
        };

        if (!stateExists) {
          $stateRegistry.register(state);
        }

        // Always transition to the state with query params to ensure they are preserved
        $state.go(stateName, queryParams, { reload: true });
      })
      .catch(() => {
        PageService.resetGlobalPage();
        $state.go('error', queryParams, { reload: true });
      });
  }

  // Only use $locationChangeStart
  $rootScope.$on('$locationChangeStart', (e) => {

    const path = $location.$$path.toLowerCase();
    const queryParams = $location.search();

    // Prevent double fetch on the same navigation event
    if (lastFetchedPath === path && JSON.stringify(queryParams) === JSON.stringify(window.lastQueryParams)) {
      return;
    }

    lastFetchedPath = path;
    window.lastQueryParams = { ...queryParams }; // Track last used query params

    // Always store current query params (useful for error redirection)
    window.locationSearch = queryParams;

    // Only handle dynamic fetch for paths not in excPath
    if (!EXCLUDED_PATHS.includes(path)) {
      e.preventDefault();
      handleDynamicRoute(path, queryParams);
    } else {
      // For excluded paths, just sync the router and preserve query params
      e.preventDefault();
      $urlRouter.sync();
      $location.search(queryParams); // Ensure query params stick around
    }

  });
}